import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "580px",
    padding: theme.spacing(3),
  },
  downloadFileInput: {
    display: "none",
  },
  taskInfo: {
    fontSize: "14px",
    color: theme.palette.grey[600],
  },
  heading: {
    fontSize: "24px",
    fontWeight: 500,
  },
  taskAttachments: {
    marginBottom: 0,
    marginTop: theme.spacing(2),
  },
  modalActionButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  submitButton: {
    marginLeft: theme.spacing(2),
  },
}));
